import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { TabBar } from "antd-mobile";
import { connect } from "react-redux";
import $ from "jquery";

import { isLoggedIn, getUserInfo } from "../../lib/session";
import "./index.less";

const Layout = ({ routeList, location, children, history, noNav }) => {
  const getPageContent = (pathname, routeList, history) => {
    let hasIcons = true;
    const result =
      routeList &&
      routeList
        .map(route => {
          const { title, path, icons, extraProps } = route;
          const { icon, selectedIcon } = icons || {};
          if (!icon && pathname === path) return;
          return (
            icon && (
              <TabBar.Item
                title={title}
                key={title}
                icon={
                  <div
                    style={{
                      width: "22px",
                      height: "22px",
                      background: `url(${icon}) center center /  21px 21px no-repeat`
                    }}
                  />
                }
                selectedIcon={
                  <div
                    style={{
                      width: "22px",
                      height: "22px",
                      background: `url(${selectedIcon}) center center /  21px 21px no-repeat`
                    }}
                  />
                }
                selected={pathname === path}
                onPress={() => history.push(path)}
                data-seed="logId"
                {...extraProps}
              />
            )
          );
        })
        .filter(n => n);
    return hasIcons && result;
  };

  const { pathname } = location;
  const tabContent = getPageContent(pathname, routeList, history);
  return (
    <section className="layout ">
      <section id="content">
        {children}
        <div className="gradient" />
      </section>
      {!noNav && (
        <section id="footer">
          <TabBar
            unselectedTintColor="#949494"
            tintColor="#33A3F4"
            barTintColor="white"
            hidden={false}
          >
            {tabContent}
          </TabBar>
        </section>
      )}
    </section>
  );
};

const mapStateToProps = state => ({
  currentlyPlaying: state.pageReducers.currentlyPlaying
});

export default connect(mapStateToProps)(withRouter(Layout));
